module.exports = __webpack_public_path__ + "static/2005-header-f64dc5f038a89b5dbffda03e1432347a.jpg";